import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Logo from "@/components/landing/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/google/session`, { session_id: sessionId })
      .then((r) => {
        localStorage.setItem("bf_admin_token", r.data.session_token);
        navigate("/admin", { replace: true });
      })
      .catch((e) => {
        const detail = e.response?.data?.detail;
        navigate("/admin", {
          replace: true,
          state: { authError: typeof detail === "string" ? detail : "Google sign-in failed. Try again." },
        });
      });
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#0B0D10]">
      <Logo size={40} />
      <p className="text-sm text-slate-400">Signing you in with Google…</p>
    </div>
  );
}
